import { render, staticRenderFns } from "./CmgNavItem.vue?vue&type=template&id=517651ec&scoped=true&lang=pug"
import script from "./cmg-nav-item.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nav-item.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNavItem.vue?vue&type=style&index=0&id=517651ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517651ec",
  null
  
)

export default component.exports